import $ from "jquery";
import { RelatedRecipesView } from "../view/related_recipes_view";
import { RelatedCombinationRecipesQuery } from "./related_combination_recipes_controller";

class RelatedRecipesController {
  public view: any;
  protected query?: RelatedRecipesQuery | RelatedCombinationRecipesQuery;

  constructor() {
    this.view = new RelatedRecipesView(this.relatedRecipesBoxElement());
  }

  protected relatedRecipesBoxElement(): JQuery<HTMLElement> {
    return $("#related_recipes_box");
  }

  initialize(): void {
    this.view.initialize();
  }

  render(): JQuery.Promise<any> {
    this.query = new RelatedRecipesQuery(this.ajaxUrl(), this.itemId());
    return this.query.execute().then(
      (recipes: any) => {
        this.view.renderRelatedRecipes(recipes);
      },
      (_res: any) => {
        this.view.renderErrorMessage("取得に失敗しました");
      },
    );
  }

  protected itemId(): string {
    return this.relatedRecipesBoxElement().data("itemId");
  }

  protected ajaxUrl(): string {
    return this.relatedRecipesBoxElement().data("ajaxUrl");
  }
}

class RelatedRecipesQuery {
  private url: string;
  private itemId: string;

  constructor(url: string, itemId: string) {
    this.url = url;
    this.itemId = itemId;
  }

  execute(): JQuery.jqXHR {
    return $.ajax({
      url: this.url,
      data: this.makeParams(),
      dataType: "json",
    });
  }

  private makeParams(): any {
    return { item_id: this.itemId };
  }
}

export { RelatedRecipesController, RelatedRecipesQuery };
